import { render, staticRenderFns } from "./InformationContent.vue?vue&type=template&id=5b89c167&scoped=true&"
import script from "./InformationContent.vue?vue&type=script&lang=js&"
export * from "./InformationContent.vue?vue&type=script&lang=js&"
import style0 from "./InformationContent.vue?vue&type=style&index=0&id=5b89c167&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b89c167",
  null
  
)

export default component.exports